export default __webpack_public_path__ + "static/media/login-bg.47520536.png";